import { filterType, filterData } from "../../../../../helpers/filterHelper";
import { store } from "../../../../../config/store";
import { showToastError, showMessageApi } from "../../../../Main/actions";
import { getCupos, getCupo, deleteCupo, createCupo, updateCupo } from "../../../../../services/mantenedoresSelApi";
import trace from "../../../../../helpers/trace";


export const loading = (isLoading) => ({
  type: "LOADING_MANTENEDOR_CUPO",
  isLoading,
});
export const doGetFiltrosCupos = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const filtros = [
      {
        column: "Status",
        name: "Activo",
        type: "bool",
        values: [
          { value: 1, text: "Si" },
          { value: 0, text: "No" },
        ],
      },
      {
        column: "Overbook",
        name: "Sobrecupo",
        values: [
          { value: true, text: "Si" },
          { value: false, text: "No" },
        ],
      },
      {
        column: "OverbookedMaximumAmount",
        name: "Máximo de sobrecupo",
        type: filterType.number,
      },
    ];
    dispatch(setFiltrosCupos(filtros));
  } catch (e) {
    trace.error("doGetFiltrosCupos", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetCupos = (filtros, reload = false) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let data = store.getState().mantenedorCupos.listaCupos;
    if (reload) {
      data = [];
    }
    let message;

    if (!data.length) {
      const request = await getCupos();
      if (request.status === 200) {
        data = await request.json();
        dispatch(setListaCupos(data));
      }
      dispatch(showMessageApi(message, request));
    }

    if (filtros) {
      const newData = filterData(data, filtros);
      dispatch(setListaCuposFiltrados(newData));
    }
  } catch (e) {
    trace.error("doGetCupos", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const setListaCupos = (data) => ({
  type: "SET_LISTA_CUPOS",
  data,
});

export const setListaCuposFiltrados = (lista) => ({
  type: "SET_LISTA_CUPOS_FILTRADOS",
  lista,
});

export const setFiltrosCupos = (filtros) => ({
  type: "SET_FILTROS_CUPOS",
  filtros,
});

export const openCloseModalEliminarCupo = (isOpen, cupo) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_CUPO",
  isOpen,
  cupo,
});

export const openCloseModalDesactivarCupo = (isOpen, cupo) => ({
  type: "OPEN_CLOSE_MODAL_DESACTIVAR_CUPO",
  isOpen,
  cupo,
});
export const doGetCupoById = (cupo) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getCupo(cupo.Id);
    let message;

    if (request.status === 200) {
      const result = await request.json();
      const data = { ...result };
      dispatch(openCloseModalEditarCupo(true, data, false));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetCupoById", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doDeleteCupo = (cupo) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await deleteCupo(cupo.Id);
    if (request.status === 200) {
      message = `Se ha eliminado el cupo ${cupo.Description}.`;
      dispatch(openCloseModalEliminarCupo(false, {}));
      dispatch(doGetCupos(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doDeleteCupo", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const setCupo = (cupo) => ({
  type: "SET_CUPO",
  cupo,
});

export const openCloseModalEditarCupo = (isOpen, cupo, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_CUPO",
  isOpen,
  cupo,
  isNew,
});

export const doAddCupo = (newRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const data = {};
    data.Description = newRow.Description;
    data.Overbook = newRow.Overbook;
    if (!newRow.Overbook) { newRow.OverbookedMaximumAmount = 0; }
    data.OverbookedMaximumAmount = newRow.OverbookedMaximumAmount;
    data.Enabled = !!newRow.Status;
    let message;
    const request = await createCupo(data);
    if (request.status === 200) {
      message = `Se ha agregado el cupo ${newRow.Description}.`;
      dispatch(doGetCupos(null, true));
      dispatch(openCloseModalEditarCupo(false, {}, false));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("AddCupos", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doUpdateCupo = (editedRow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const data = {};
    data.Id = editedRow.Id;
    data.Description = editedRow.Description;
    data.Overbook = editedRow.Overbook;
    if (!editedRow.Overbook) { editedRow.OverbookedMaximumAmount = 0; }
    data.OverbookedMaximumAmount = editedRow.OverbookedMaximumAmount;
    data.Enabled = !!editedRow.Status;
    let message;
    const request = await updateCupo(data);
    if (request.status === 200) {
      message = `Se ha editado el cupo ${editedRow.Description}.`;
      dispatch(openCloseModalEditarCupo(false, {}, false));
      dispatch(openCloseModalDesactivarCupo(false, {}, false));
      dispatch(doGetCupos(null, true));
      dispatch(showMessageApi(message, request));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doUpdateCupo", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
